"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = exports.CardContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const style_1 = __importDefault(require("style"));
exports.CardContainer = styled_components_1.default.div `
  ${style_1.default.Depth.Definition.LightShadow};
  background: ${props => props.theme.Color.Layout.Lightest};
  border-radius: ${style_1.default.Design.Rounding.Secondary};
`;
const Card = ({ children, }) => {
    return ((0, jsx_runtime_1.jsx)(exports.CardContainer, { children: children }));
};
exports.Card = Card;
